import {useQuery} from '@tanstack/react-query';
import {listSegments} from '@/api/fetchers/segments';

const SEGMENTS_QUERY_KEY = 'segments';

export interface UseSegmentsQueryOptions {
  merchantId: string;
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}

export default function useSegmentsQuery({
  merchantId,
  enabled = true,
  refetchOnWindowFocus = true,
}: UseSegmentsQueryOptions) {
  return useQuery({
    queryKey: [SEGMENTS_QUERY_KEY, merchantId],
    queryFn: () => listSegments(merchantId),
    enabled: enabled && !!merchantId,
    refetchOnWindowFocus,
  });
}

export {SEGMENTS_QUERY_KEY};
